import {interpolate, getFormat} from './i18n';

const Plus = '';
const Minus = '-';

/**
 * @param {Number} value
 * @returns {String}
 */
const formatCurrency = value => {
    const decimalSeparator = getFormat('DECIMAL_SEPARATOR');
    const thousandSeparator = getFormat('THOUSAND_SEPARATOR');
    const [significant, decimal] = value.toFixed(2).split('.');
    const [sign, number] = significant.indexOf(Minus) === 0
        ? [Minus, significant.substr(1)]
        : [Plus, significant];

    if (number.length <= 3) return sign + number + decimalSeparator + decimal;

    const remainder = number.length % 3;
    const groups = [];
    let tail = number;
    let head;

    if (remainder) {
        head = number.substr(0, remainder);
        tail = number.substr(remainder);
        groups.push(head);
    }

    for (let start = 0; start < tail.length; start += 3) {
        groups.push(tail.substr(start, 3));
    }

    return sign + groups.join(thousandSeparator) + decimalSeparator + decimal;
};

/**
 * @param {String} template
 * @param {String} symbol
 * @param {Number} value
 * @returns {String}
 */
function format({template, symbol}, value) {
    const context = {
        value: formatCurrency(value),
        currency: symbol,
    };

    return interpolate(template, context);
}

export default format;
